import React, { useState, useEffect } from "react";
import { Instagram, Facebook, Phone, ArrowDown } from "lucide-react";

const Hero = ({ scrollToSection }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center pt-20 bg-cover"
      style={{
        backgroundImage: "url('/cover.jpg')",
        backgroundPosition: "80% center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="absolute inset-0 bg-black/50" />
      
      <div className="relative z-10 text-center px-6">
        {/* Main Title */}
        <h1
          className={`text-7xl md:text-8xl font-bold mb-3 mt-20 text-gray-100 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          KEMO
        </h1>
        
        <p
          className={`text-2xl md:text-3xl text-gray-400 mb-8 transition-all duration-1000 delay-100 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          PHOTOGRAPHY
        </p>

        {/* CTA Buttons */}
        <div
          className={`flex flex-col sm:flex-row justify-center gap-6 mb-12 transition-all duration-1000 delay-200 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <button
            onClick={() => scrollToSection("portfolio")}
            className="group px-10 py-4 bg-gradient-to-r from-gray-700 to-gray-600 rounded-full text-lg font-medium hover:shadow-2xl hover:scale-105 transition-all duration-300 overflow-hidden relative"
          >
            <span className="relative z-10">شاهد أعمالي</span>
            {/* Shine Effect */}
            <div className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700">
              <div className="h-full w-10 bg-white/20 skew-x-12" />
            </div>
          </button>
          
          <button
            onClick={() => scrollToSection("contact")}
            className="group px-10 py-4 border-2 border-gray-600 rounded-full text-lg font-medium hover:bg-gray-800 hover:border-gray-500 transition-all duration-300"
          >
            <span className="flex items-center justify-center gap-2">
              تواصل معي
              <ArrowDown className="w-5 h-5 group-hover:translate-y-1 transition-transform duration-300" />
            </span>
          </button>
        </div>

        {/* Social Links */}
        <div
          className={`flex justify-center gap-6 transition-all duration-1000 delay-300 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <a
            href="https://instagram.com/Kemaa111"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative w-14 h-14 bg-gray-800 hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
          >
            {/* Glow Effect */}
            <div className="absolute -inset-1 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full blur-lg opacity-0 group-hover:opacity-70 transition-opacity duration-300" />
            <Instagram className="w-6 h-6 relative z-10" />
          </a>
          
          <a
            href="https://www.facebook.com/kemodaana22"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative w-14 h-14 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
          >
            {/* Glow Effect */}
            <div className="absolute -inset-1 bg-blue-600 rounded-full blur-lg opacity-0 group-hover:opacity-70 transition-opacity duration-300" />
            <Facebook className="w-6 h-6 relative z-10" />
          </a>
          
          <a
            href="tel:01158228319"
            className="group relative w-14 h-14 bg-gray-800 hover:bg-green-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
          >
            {/* Glow Effect */}
            <div className="absolute -inset-1 bg-green-600 rounded-full blur-lg opacity-0 group-hover:opacity-70 transition-opacity duration-300" />
            <Phone className="w-6 h-6 relative z-10" />
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div
        className={`absolute bottom-10 left-1/2 -translate-x-1/2 transition-all duration-1000 delay-500 ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
      >
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <ArrowDown className="w-5 h-5 text-white/60" />
        </div>
      </div>
    </section>
  );
};

export default Hero;